// Google Tag Manager / Analytics tracking service

declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Push a custom event to Google Tag Manager dataLayer
 * @param eventName - The name of the event to track
 * @param eventParams - Optional parameters to send with the event
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    });
    console.log('GTM Event tracked:', eventName, eventParams);
  } else {
    console.warn('GTM dataLayer not available');
  }
};

export const trackDinnerPartyStart = () => {
  trackEvent('dinner_party_start', {
    category: 'Dinner Party',
    action: 'Start',
    label: 'User clicked Start a dinner party button',
  });
};

export const trackDinnerPartySeeInterests = (userCount: number) => {
  trackEvent('dinner_party_see_interests', {
    category: 'Dinner Party',
    action: 'See Interests',
    label: 'User clicked See interests button',
    userCount: userCount,
  });
};
